<template>
  <div class="pa-16 pt-6">
    <app-pdf-preview
      :value="value"
      :queryParams="$route.query"
      @loadDone="onLoadDone"
    />
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Boolean,
      default: false
    }
  },

  methods: {
    onLoadDone() {
      this.$emit('input', false)
    }
  }
}
</script>

<style lang="scss" scoped></style>
